// extracted by css-extract-rspack-plugin
export default {"Box":"AddSubIssueButtonGroup-module__Box__azdei","feedback":"AddSubIssueButtonGroup-module__feedback__x_Zfo","feedbackIcon":"AddSubIssueButtonGroup-module__feedbackIcon___EMLE"};